function getSliderSettings() {
	return {
		slidesPerView: 1,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	};
}

function getSubSliderProductSettings() {
	return {
		slidesPerView: "auto",
		direction: "vertical",
		navigation: false,
	};
}

const sliderInit = (isUpdate) => {
	if (
		document.querySelectorAll(".product-section .js-media-list") &&
		document.querySelectorAll(".product-section .js-media-list").length > 0
	) {
		let slider = new Swiper(".product-section .js-media-list", {
			slidesPerView: 1,
			autoHeight: true,
			navigation: {
				nextEl: ".swiper-btn--next",
				prevEl: ".swiper-btn--prev",
			},
			thumbs: {
				swiper: document.querySelector(".product-section .js-media-sublist")
					.swiper,
			},
			on: {
				slideChangeTransitionStart: function () {
					document
						.querySelector(".product-section .js-media-sublist")
						.swiper.slideTo(
							document.querySelector(".product-section .js-media-list").swiper
								.activeIndex,
						);
				},
				slideChange: function () {
					window.pauseAllMedia();
					this.params.noSwiping = false;
				},
				slideChangeTransitionEnd: function () {
					if (this.slides[this.activeIndex].querySelector("model-viewer")) {
						this.slides[this.activeIndex]
							.querySelector(".shopify-model-viewer-ui__button--poster")
							.removeAttribute("hidden");
					}
				},
				touchStart: function (s, e) {
					if (this.slides[this.activeIndex].querySelector("model-viewer")) {
						if (
							!this.slides[this.activeIndex]
								.querySelector("model-viewer")
								.classList.contains("shopify-model-viewer-ui__disabled")
						) {
							this.params.noSwiping = true;
							this.params.noSwipingClass = "swiper-slide";
						}
					}
				},
			},
		});

		if (isUpdate) {
			setTimeout(function () {
				slider.update();
			}, 800);
		}
	}
};

const subSliderInit = (isUpdate) => {
	if (
		document.querySelectorAll(".product-section .js-media-sublist") &&
		document.querySelectorAll(".product-section .js-media-sublist").length > 0
	) {
		let subSlider = new Swiper(".product-section .js-media-sublist", {
			centeredSlides: true,
			centeredSlidesBounds: true,
			slidesPerView: 3,
			spaceBetween: 8,
			direction: "horizontal",
			navigation: false,
			freeMode: false,
			watchSlidesProgress: true,
			on: {
				afterInit: function () {
					if (window.matchMedia('(min-width: 1200px)').matches) {
						if (this.el.querySelector('.swiper-wrapper').scrollHeight > 586) {
							this.el.classList.add('delimiter');
						} else {
							this.el.classList.remove('delimiter');
						}
					}
				},
				touchEnd: function (s, e) {
					let range = 5;
					let diff = (s.touches.diff = s.isHorizontal()
						? s.touches.currentX - s.touches.startX
						: s.touches.currentY - s.touches.startY);
					if (diff < range || diff > -range) s.allowClick = true;
				},
			},
			transitionStart: function () {
				document
					.querySelector(".product-section .js-media-list")
					.swiper.slideTo(
						document.querySelector(".product-section.js-media-sublist").swiper
							.activeIndex,
					);
			},
			breakpoints: {
				1200: {
					direction: "vertical",
					slidesPerView: "auto",
					centeredSlides: false,
					allowTouchMove: false,
				},
			},
		});

		if (isUpdate) {
			setTimeout(function () {
				subSlider.update();
			}, 800);
		}
	}
};

function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
		),
	);
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute("role", "button");
	summary.setAttribute("aria-expanded", "false");

	if (summary.nextElementSibling.getAttribute("id")) {
		summary.setAttribute("aria-controls", summary.nextElementSibling.id);
	}

	summary.addEventListener("click", (event) => {
		event.currentTarget.setAttribute(
			"aria-expanded",
			!event.currentTarget.closest("details").hasAttribute("open"),
		);
	});

	if (summary.closest("header-drawer")) return;
	summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== "ESCAPE") return;

	const openDetailsElement = event.target.closest("details[open]");
	if (!openDetailsElement) return;

	const summaryElement = openDetailsElement.querySelector("summary");
	openDetailsElement.removeAttribute("open");
	summaryElement.setAttribute("aria-expanded", false);
	summaryElement.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container);
	var first = elements[0];
	var last = elements[elements.length - 1];

	removeTrapFocus();

	trapFocusHandlers.focusin = (event) => {
		if (
			event.target !== container &&
			event.target !== last &&
			event.target !== first
		)
			return;

		document.addEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.focusout = function () {
		document.removeEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus();
		}

		//  On the first focusable element and tab backward, focus the last element.
		if (
			(event.target === container || event.target === first) &&
			event.shiftKey
		) {
			event.preventDefault();
			last.focus();
		}
	};

	document.addEventListener("focusout", trapFocusHandlers.focusout);
	document.addEventListener("focusin", trapFocusHandlers.focusin);

	elementToFocus.focus();
}

function pauseAllMedia() {
	document.querySelectorAll(".js-youtube").forEach((video) => {
		video.contentWindow.postMessage(
			'{"event":"command","func":"' + "pauseVideo" + '","args":""}',
			"*",
		);
	});
	document.querySelectorAll(".js-vimeo").forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', "*");
	});
	document.querySelectorAll("video").forEach((video) => video.pause());
	document.querySelectorAll("product-model").forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause();
	});
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener("focusin", trapFocusHandlers.focusin);
	document.removeEventListener("focusout", trapFocusHandlers.focusout);
	document.removeEventListener("keydown", trapFocusHandlers.keydown);

	if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector("input");
		this.changeEvent = new Event("change", { bubbles: true });

		this.querySelectorAll("button").forEach((button) =>
			button.addEventListener("click", this.onButtonClick.bind(this)),
		);

		var eventList = ["paste", "input"];

		for (event of eventList) {
			this.input.addEventListener(event, function (e) {
				const numberRegex = /^0*?[1-9]\d*$/;

				if (
					numberRegex.test(e.currentTarget.value) ||
					e.currentTarget.value === ""
				) {
					e.currentTarget.value;
				} else {
					e.currentTarget.value = 1;
				}
			});
		}

		this.input.addEventListener("focusout", function (e) {
			if (e.currentTarget.value === "") {
				e.currentTarget.value = 1;
			}
		});
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;

		event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
		if (previousValue !== this.input.value)
			this.input.dispatchEvent(this.changeEvent);
	}
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

const serializeForm = (form) => {
	const obj = {};
	const formData = new FormData(form);
	for (const key of formData.keys()) {
		obj[key] = formData.get(key);
	}
	return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
	return {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: `application/${type}`,
		},
	};
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
	window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
	options = options || {};
	var method = options["method"] || "post";
	var params = options["parameters"] || {};

	var form = document.createElement("form");
	form.setAttribute("method", method);
	form.setAttribute("action", path);

	for (var key in params) {
		var hiddenField = document.createElement("input");
		hiddenField.setAttribute("type", "hidden");
		hiddenField.setAttribute("name", key);
		hiddenField.setAttribute("value", params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
	country_domid,
	province_domid,
	options,
) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(
		options["hideElement"] || province_domid,
	);

	Shopify.addListener(
		this.countryEl,
		"change",
		Shopify.bind(this.countryHandler, this),
	);

	this.initCountry();
	this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute("data-default");
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute("data-default");
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value);
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex];
		var raw = opt.getAttribute("data-provinces");
		var provinces = JSON.parse(raw);

		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = "none";
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement("option");
				opt.value = provinces[i][0];
				opt.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(opt);
			}

			this.provinceContainer.style.display = "";
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild);
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement("option");
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	},
};

class MenuDrawer extends HTMLElement {
	constructor() {
		super();

		this.mainDetailsToggle = this.querySelector("details");
		const summaryElements = this.querySelectorAll("summary");
		this.addAccessibilityAttributes(summaryElements);

		if (navigator.platform === "iPhone")
			document.documentElement.style.setProperty(
				"--viewport-height",
				`${window.innerHeight}px`,
			);

		this.addEventListener("keyup", this.onKeyUp.bind(this));
		this.addEventListener("focusout", this.onFocusOut.bind(this));
		this.bindEvents();
	}

	bindEvents() {
		this.querySelectorAll("summary").forEach((summary) =>
			summary.addEventListener("click", this.onSummaryClick.bind(this)),
		);
		this.querySelectorAll("button").forEach((button) => {
			if (this.querySelector(".header__localization-button") === button) return;
			if (this.querySelector(".header__localization-lang-button") === button) return;
			button.addEventListener("click", this.onCloseButtonClick.bind(this));
		});
	}

	addAccessibilityAttributes(summaryElements) {
		summaryElements.forEach((element) => {
			element.setAttribute("role", "button");
			element.setAttribute("aria-expanded", false);
			element.setAttribute("aria-controls", element.nextElementSibling.id);
		});
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== "ESCAPE") return;

		const openDetailsElement = event.target.closest("details[open]");
		if (!openDetailsElement) return;

		openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
			: this.closeSubmenu(openDetailsElement);
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget;
		const detailsElement = summaryElement.parentNode;
		const isOpen = detailsElement.hasAttribute("open");

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault();
			isOpen
				? this.closeMenuDrawer(summaryElement)
				: this.openMenuDrawer(summaryElement);
		} else {
			trapFocus(
				summaryElement.nextElementSibling,
				detailsElement.querySelector("button"),
			);

			setTimeout(() => {
				detailsElement.classList.add("menu-opening");
			});
		}
	}

	openMenuDrawer(summaryElement) {
		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening");
		});
		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event !== undefined) {
			this.mainDetailsToggle.classList.remove("menu-opening");
			this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
				details.removeAttribute("open");
				details.classList.remove("menu-opening");
			});
			this.mainDetailsToggle
				.querySelector("summary")
				.setAttribute("aria-expanded", false);
			document.body.classList.remove(
				`overflow-hidden-${this.dataset.breakpoint}`,
			);
			removeTrapFocus(elementToFocus);
			this.closeAnimation(this.mainDetailsToggle);
		}
	}

	onFocusOut(event) {
		setTimeout(() => {
			if (
				this.mainDetailsToggle.hasAttribute("open") &&
				!this.mainDetailsToggle.contains(document.activeElement)
			)
				this.closeMenuDrawer();
		});
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest("details");
		this.closeSubmenu(detailsElement);
	}

	closeSubmenu(detailsElement) {
		detailsElement.classList.remove("menu-opening");
		removeTrapFocus();
		this.closeAnimation(detailsElement);
	}

	closeAnimation(detailsElement) {
		let animationStart;

		const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time;
			}

			const elapsedTime = time - animationStart;

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation);
			} else {
				detailsElement.removeAttribute("open");
				if (detailsElement.closest("details[open]")) {
					trapFocus(
						detailsElement.closest("details[open]"),
						detailsElement.querySelector("summary"),
					);
				}
			}
		};

		window.requestAnimationFrame(handleAnimation);
	}
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super();
	}

	openMenuDrawer(summaryElement) {
		this.header =
			this.header || document.querySelector(".shopify-section-header");
		this.borderOffset =
			this.borderOffset ||
			this.closest(".header-wrapper").classList.contains(
				"header-wrapper--border-bottom",
			)
				? 1
				: 0;
		document.documentElement.style.setProperty(
			"--header-bottom-position",
			`${parseInt(
				this.header.getBoundingClientRect().bottom - this.borderOffset,
			)}px`,
		);

		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening");
		});

		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="ModalClose-"]').addEventListener(
			"click",
			this.hide.bind(this, false),
		);
		this.addEventListener("keyup", (event) => {
			if (event.code.toUpperCase() === "ESCAPE") this.hide();
		});
		if (this.classList.contains("media-modal")) {
			this.addEventListener("pointerup", (event) => {
				if (
					event.pointerType === "mouse" &&
					!event.target.closest("deferred-media, product-model")
				)
					this.hide();
			});
		} else {
			this.addEventListener("click", (event) => {
				if (event.target === this) this.hide();
			});
		}
	}

	connectedCallback() {
		if (this.moved) return;
		this.moved = true;
		document.body.appendChild(this);
	}

	show(opener) {
		this.openedBy = opener;
		const popup = this.querySelector(".template-popup");
		document.body.classList.add("overflow-hidden");
		this.setAttribute("open", "");
		if (popup) popup.loadContent();
		trapFocus(this, this.querySelector('[role="dialog"]'));
		window.pauseAllMedia();
	}

	hide() {
		let isOpen = false;

		this.removeAttribute("open");
		removeTrapFocus(this.openedBy);
		window.pauseAllMedia();

		document.querySelectorAll("body > quick-add-modal").forEach((el) => {
			if (el.hasAttribute("open")) {
				isOpen = true;
			}
		});

		if (!isOpen) {
			document.body.classList.remove("overflow-hidden");
			document.body.dispatchEvent(new CustomEvent("modalClosed"));
		}
	}
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
	constructor() {
		super();

		const button = this.querySelector("button");

		if (!button) return;
		button.addEventListener("click", () => {
			const modal = document.querySelector(this.getAttribute("data-modal"));
			if (modal) modal.show(button);
		});
	}
}

customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
			"click",
			this.loadContent.bind(this),
		);
		if (this.getAttribute("data-autoplay")) {
			this.loadContent();
		}
	}

	loadContent() {
		if (!this.getAttribute("loaded")) {
			const content = document.createElement("div");
			content.appendChild(
				this.querySelector("template").content.firstElementChild.cloneNode(
					true,
				),
			);

			this.setAttribute("loaded", true);
			window.pauseAllMedia();

			/*this.appendChild(
				content.querySelector("video, model-viewer, iframe"),
			).focus();*/

			const videoObserver = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							if (this.getAttribute("data-autoplay")) {
								let playPromise = entry.target.play();
								if (playPromise !== undefined) {
									playPromise.then(_ => {}).catch(error => {});
								}
								//entry.target.play()
							}
						}
						else {
							entry.target.pause()
						}
					})
				}
			)

			const deferredElement = this.appendChild(
				content.querySelector("video, model-viewer, iframe")
			);			
			//if (focus) deferredElement.focus();
			
			if (
				deferredElement.nodeName == "VIDEO" ||
				deferredElement.nodeName == "IFRAME"
			) {
				// force autoplay for safari

				
				if (this.classList.contains('video-section__media')) {
					let playPromise = deferredElement.play();
					if (playPromise !== undefined) {
						playPromise.then(_ => {}).catch(error => {});
					}

					videoObserver.observe(deferredElement);
				}
				else {
					deferredElement.play();
				}
			}

			if (
				this.closest(".swiper")?.swiper.slides[
					this.closest(".swiper").swiper.activeIndex
				].querySelector("model-viewer")
			) {
				if (
					!this.closest(".swiper")
						.swiper.slides[
							this.closest(".swiper").swiper.activeIndex
						].querySelector("model-viewer")
						.classList.contains("shopify-model-viewer-ui__disabled")
				) {
					this.closest(".swiper").swiper.params.noSwiping = true;
					this.closest(".swiper").swiper.params.noSwipingClass = "swiper-slide";
				}
			}
		}
	}
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
	constructor() {
		super();
		this.slider = this.querySelector(".slider");
		this.sliderItems = this.querySelectorAll(".slider__slide");
		this.pageCount = this.querySelector(".slider-counter--current");
		this.pageTotal = this.querySelector(".slider-counter--total");
		this.prevButton = this.querySelector('button[name="previous"]');
		this.nextButton = this.querySelector('button[name="next"]');

		if (!this.slider || !this.nextButton) return;

		const resizeObserver = new ResizeObserver((entries) => this.initPages());
		resizeObserver.observe(this.slider);

		this.slider.addEventListener("scroll", this.update.bind(this));
		this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
		this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
	}

	initPages() {
		if (!this.sliderItems.length === 0) return;
		this.slidesPerPage = Math.floor(
			this.slider.clientWidth / this.sliderItems[0].clientWidth,
		);
		this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
		this.update();
	}

	update() {
		if (!this.pageCount || !this.pageTotal) return;
		this.currentPage =
			Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

		if (this.currentPage === 1) {
			this.prevButton.setAttribute("disabled", true);
		} else {
			this.prevButton.removeAttribute("disabled");
		}

		if (this.currentPage === this.totalPages) {
			this.nextButton.setAttribute("disabled", true);
		} else {
			this.nextButton.removeAttribute("disabled");
		}

		this.pageCount.textContent = this.currentPage;
		this.pageTotal.textContent = this.totalPages;
	}

	onButtonClick(event) {
		event.preventDefault();
		const slideScrollPosition =
			event.currentTarget.name === "next"
				? this.slider.scrollLeft + this.sliderItems[0].clientWidth
				: this.slider.scrollLeft - this.sliderItems[0].clientWidth;
		this.slider.scrollTo({
			left: slideScrollPosition,
		});
	}
}

customElements.define("slider-component", SliderComponent);

class VariantSelects extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("change", this.onVariantChange);
	}

	onVariantChange() {
		this.updateOptions();
		this.updateMasterId();
		this.toggleAddButton(true, "", false);
		this.updatePickupAvailability();
		this.updateVariantStatuses();

		if (!this.currentVariant) {
			this.toggleAddButton(true, "", true);
			this.setUnavailable();
		} else {
			this.updateMediaSub();
			this.updateMedia();
			this.updateURL();
			this.updateVariantInput();
			this.renderProductInfo();
		}
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll(".js-radio-colors"));

		this.options = Array.from(
			this.querySelectorAll("select"),
			(select) => select.value,
		).concat(
			fieldsets.map((fieldset) => {

				return Array.from(fieldset.querySelectorAll("input")).find(
					(radio) => radio.checked,
				).value;
			})
		);
	}

	updateMasterId() {
		if (this.variantData || this.querySelector('[type="application/json"]')) {
			this.currentVariant = this.getVariantData().find((variant) => {
				this.options.sort();
				variant.options.sort();

				return !variant.options
					.map((option, index) => {
						return this.options[index] === option;
					})
					.includes(false);
			});
		}
	}

	updateMedia() {
		if (!this.currentVariant || !this.currentVariant?.featured_media) return;

		const newMedia = document.querySelector(
			`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`,
		);

		if (!newMedia) return;

		const parent = newMedia.parentElement;

		parent.prepend(newMedia);

		window.setTimeout(() => {
			parent.scroll(0, 0);
		});

		if (document.querySelector(".js-media-list")) {
			sliderInit();
		}
	}

	updateMediaSub() {
		if (!this.currentVariant || !this.currentVariant?.featured_media) return;

		const newMediaSub = document.querySelector(
			`[data-media-sub-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`,
		);

		if (
			document.querySelector(".js-media-sublist") &&
			document.querySelector(".js-media-sublist").swiper != null
		) {
			document.querySelector(".js-media-sublist").swiper.destroy();
		}

		if (!newMediaSub) return;

		const parentSub = newMediaSub.parentElement;

		parentSub.prepend(newMediaSub);

		window.setTimeout(() => {
			parentSub.scroll(0, 0);
		});

		if (document.querySelector(".js-media-sublist")) {
			subSliderInit();
		}
	}

	updateURL() {
		if (!this.currentVariant || this.dataset.updateUrl === "false") return;
		window.history.replaceState(
			{},
			"",
			`${this.dataset.url}?variant=${this.currentVariant.id}`,
		);
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
		);
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]');
			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event("change", { bubbles: true }));
		});
	}

	updateVariantStatuses() {
		const selectedOptionOneVariants = this.variantData.filter(
			(variant) => this.querySelector(":checked").value === variant.option1,
		);
		const inputWrappers = [...this.querySelectorAll(".product-form__input")];
		inputWrappers.forEach((option, index) => {
			if (index === 0) return;
			const optionInputs = [
				...option.querySelectorAll('input[type="radio"], option'),
			];
			const previousOptionSelected =
				inputWrappers[index - 1].querySelector(":checked").value;
			const availableOptionInputsValue = selectedOptionOneVariants
				.filter(
					(variant) =>
						variant.available &&
						variant[`option${index}`] === previousOptionSelected
				)
				.map((variantOption) => variantOption[`option${index + 1}`]);
			this.setInputAvailability(optionInputs, availableOptionInputsValue);
		});
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
				if (input.tagName === 'OPTION') {
					input.innerText = input.getAttribute("value");
				} else if (input.tagName === 'INPUT') {
					input.classList.remove("disabled");
				}
			} else {
				if (input.tagName === 'OPTION') {
					input.innerText = window.variantStrings.unavailable_with_option.replace(
						"[value]",
						input.getAttribute("value"),
					);
				} else if (input.tagName === 'INPUT') {
					input.classList.add("disabled");
				}
			}
		});
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector("pickup-availability");
		if (!pickUpAvailability) return;

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id);
		} else {
			pickUpAvailability.removeAttribute("available");
			pickUpAvailability.innerHTML = "";
		}
	}

	renderProductInfo() {
		const requestedVariantId = this.currentVariant.id;
		const sectionId = this.dataset.originalSection
			? this.dataset.originalSection
			: this.dataset.section;

		fetch(
			`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
				this.dataset.originalSection
					? this.dataset.originalSection
					: this.dataset.section
			}`,
		)
			.then((response) => response.text())
			.then((responseText) => {
				// prevent unnecessary ui changes from abandoned selections
				if (this.currentVariant.id !== requestedVariantId) return;

				const html = new DOMParser().parseFromString(responseText, "text/html");
				const destination = document.getElementById(
					`price-${this.dataset.section}`,
				);
				const source = html.getElementById(
					`price-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`,
				);
				const skuSource = html.getElementById(
					`Sku-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`,
				);
				const skuDestination = document.getElementById(
					`Sku-${this.dataset.section}`,
				);
				const inventorySource = html.getElementById(
					`Inventory-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`,
				);
				const inventoryDestination = document.getElementById(
					`Inventory-${this.dataset.section}`,
				);

				if (source && destination) destination.innerHTML = source.innerHTML;
				if (inventorySource && inventoryDestination)
					inventoryDestination.innerHTML = inventorySource.innerHTML;
				if (skuSource && skuDestination) {
					skuDestination.innerHTML = skuSource.innerHTML;
					skuDestination.classList.toggle(
						"visibility-hidden",
						skuSource.classList.contains("visibility-hidden"),
					);
				}

				const price = document.getElementById(`price-${this.dataset.section}`);

				if (price) price.classList.remove("visibility-hidden");

				if (inventoryDestination)
					inventoryDestination.classList.toggle(
						"visibility-hidden",
						inventorySource.innerText === "",
					);

				const addButtonUpdated = html.getElementById(
					`ProductSubmitButton-${sectionId}`,
				);
				this.toggleAddButton(
					addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
					window.variantStrings.soldOut,
				);
			});
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		const productForm = document.getElementById(
			`product-form-${this.dataset.section}`,
		);
		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]');
		const addButtonText = productForm.querySelectorAll('[name="add"] > span');
		if (!addButton) return;

		if (disable) {
			addButton.setAttribute("disabled", "disabled");

			if (text) {
				addButtonText.forEach((elem) => {
					elem.innerHTML = `${text}<svg class="icon icon-cart" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 17" fill="none">
<path d="M3.25 6V4.5C3.25 3.50544 3.64509 2.55161 4.34835 1.84835C5.05161 1.14509 6.00544 0.75 7 0.75C7.99456 0.75 8.94839 1.14509 9.65165 1.84835C10.3549 2.55161 10.75 3.50544 10.75 4.5V6H13C13.1989 6 13.3897 6.07902 13.5303 6.21967C13.671 6.36032 13.75 6.55109 13.75 6.75V15.75C13.75 15.9489 13.671 16.1397 13.5303 16.2803C13.3897 16.421 13.1989 16.5 13 16.5H1C0.801088 16.5 0.610322 16.421 0.46967 16.2803C0.329018 16.1397 0.25 15.9489 0.25 15.75V6.75C0.25 6.55109 0.329018 6.36032 0.46967 6.21967C0.610322 6.07902 0.801088 6 1 6H3.25ZM3.25 7.5H1.75V15H12.25V7.5H10.75V9H9.25V7.5H4.75V9H3.25V7.5ZM4.75 6H9.25V4.5C9.25 3.90326 9.01295 3.33097 8.59099 2.90901C8.16903 2.48705 7.59674 2.25 7 2.25C6.40326 2.25 5.83097 2.48705 5.40901 2.90901C4.98705 3.33097 4.75 3.90326 4.75 4.5V6Z" fill="currentColor"/>
</svg>`;
				});
			}
		} else {
			addButton.removeAttribute("disabled");
			addButtonText.forEach((elem) => {
				elem.innerHTML = `${window.variantStrings.addToCart}<svg class="icon icon-cart" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 17" fill="none">
<path d="M3.25 6V4.5C3.25 3.50544 3.64509 2.55161 4.34835 1.84835C5.05161 1.14509 6.00544 0.75 7 0.75C7.99456 0.75 8.94839 1.14509 9.65165 1.84835C10.3549 2.55161 10.75 3.50544 10.75 4.5V6H13C13.1989 6 13.3897 6.07902 13.5303 6.21967C13.671 6.36032 13.75 6.55109 13.75 6.75V15.75C13.75 15.9489 13.671 16.1397 13.5303 16.2803C13.3897 16.421 13.1989 16.5 13 16.5H1C0.801088 16.5 0.610322 16.421 0.46967 16.2803C0.329018 16.1397 0.25 15.9489 0.25 15.75V6.75C0.25 6.55109 0.329018 6.36032 0.46967 6.21967C0.610322 6.07902 0.801088 6 1 6H3.25ZM3.25 7.5H1.75V15H12.25V7.5H10.75V9H9.25V7.5H4.75V9H3.25V7.5ZM4.75 6H9.25V4.5C9.25 3.90326 9.01295 3.33097 8.59099 2.90901C8.16903 2.48705 7.59674 2.25 7 2.25C6.40326 2.25 5.83097 2.48705 5.40901 2.90901C4.98705 3.33097 4.75 3.90326 4.75 4.5V6Z" fill="currentColor"/>
</svg>`;
			});
		}

		if (!modifyClass) return;
	}

	setUnavailable() {
		const button = document.getElementById(
			`product-form-${this.dataset.section}`,
		);
		const addButton = button.querySelector('[name="add"]');
		const addButtonText = button.querySelectorAll('[name="add"] > span');
		const price = document.getElementById(`price-${this.dataset.section}`);
		const inventory = document.getElementById(
			`Inventory-${this.dataset.section}`,
		);
		const sku = document.getElementById(`Sku-${this.dataset.section}`);
		if (!addButton) return;
		addButtonText.forEach((elem) => {
			elem.innerHTML = `${window.variantStrings.unavailable}<svg class="icon icon-cart" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 17" fill="none">
<path d="M3.25 6V4.5C3.25 3.50544 3.64509 2.55161 4.34835 1.84835C5.05161 1.14509 6.00544 0.75 7 0.75C7.99456 0.75 8.94839 1.14509 9.65165 1.84835C10.3549 2.55161 10.75 3.50544 10.75 4.5V6H13C13.1989 6 13.3897 6.07902 13.5303 6.21967C13.671 6.36032 13.75 6.55109 13.75 6.75V15.75C13.75 15.9489 13.671 16.1397 13.5303 16.2803C13.3897 16.421 13.1989 16.5 13 16.5H1C0.801088 16.5 0.610322 16.421 0.46967 16.2803C0.329018 16.1397 0.25 15.9489 0.25 15.75V6.75C0.25 6.55109 0.329018 6.36032 0.46967 6.21967C0.610322 6.07902 0.801088 6 1 6H3.25ZM3.25 7.5H1.75V15H12.25V7.5H10.75V9H9.25V7.5H4.75V9H3.25V7.5ZM4.75 6H9.25V4.5C9.25 3.90326 9.01295 3.33097 8.59099 2.90901C8.16903 2.48705 7.59674 2.25 7 2.25C6.40326 2.25 5.83097 2.48705 5.40901 2.90901C4.98705 3.33097 4.75 3.90326 4.75 4.5V6Z" fill="currentColor"/>
</svg>`;
		});
		if (price) price.classList.add("visibility-hidden");
		if (inventory) inventory.classList.add("visibility-hidden");
		if (sku) sku.classList.add("visibility-hidden");
	}

	getVariantData() {
		this.variantData =
			this.variantData ||
			JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
	constructor() {
		super();
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
				input.classList.remove("disabled");
			} else {
				input.classList.add("disabled");
			}
		});
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll("fieldset"));
		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll("input")).find(
				(radio) => radio.checked,
			).value;
		});
	}
}

customElements.define("variant-radios", VariantRadios);

class ProductModel extends DeferredMedia {
	constructor() {
		super();
	}

	loadContent() {
		super.loadContent();

		Shopify.loadFeatures([
			{
				name: "model-viewer-ui",
				version: "1.0",
				onLoad: this.setupModelViewerUI.bind(this),
			},
		]);
	}

	setupModelViewerUI(errors) {
		if (errors) return;

		this.modelViewerUI = new Shopify.ModelViewerUI(
			this.querySelector("model-viewer"),
		);

		const $this = this;

		this.querySelector(".shopify-model-viewer-ui__button").addEventListener(
			"click",
			function () {
				if (
					$this
						.closest(".swiper")
						.swiper.slides[
							$this.closest(".swiper").swiper.activeIndex
						].querySelector("model-viewer")
				) {
					if (
						!$this
							.closest(".swiper")
							.swiper.slides[
								$this.closest(".swiper").swiper.activeIndex
							].querySelector("model-viewer")
							.classList.contains("shopify-model-viewer-ui__disabled")
					) {
						if (
							$this
								.querySelector(".shopify-model-viewer-ui__button")
								.hasAttribute("hidden")
						) {
							$this.closest(".swiper").swiper.params.noSwiping = true;
							$this.closest(".swiper").swiper.params.noSwipingClass =
								"swiper-slide";
						}
					}
				}
			},
		);

		this.querySelector(
			".shopify-model-viewer-ui__controls-overlay",
		).addEventListener("click", function () {
			if (
				!$this
					.querySelector(".shopify-model-viewer-ui__button")
					.hasAttribute("hidden")
			) {
				$this.closest(".swiper").swiper.params.noSwiping = false;
			}
		});
	}
}
customElements.define("product-model", ProductModel);

(function () {
	const imageMouseParallax = (options) => {
		options = options || {};
		this.nameSpaces = {
			wrapper: options.wrapper || ".parallax",
			layers: options.layers || ".parallax-layer",
			deep: options.deep || "data-parallax-deep",
		};

		this.init = function () {
			var self = this;
			var parallaxWrappers = document.querySelectorAll(this.nameSpaces.wrapper);

			for (var i = 0; i < parallaxWrappers.length; i++) {
				(function (i) {
					parallaxWrappers[i].addEventListener("mousemove", function (e) {
						var x = e.clientX;
						var y = e.clientY;
						var layers = parallaxWrappers[i].querySelectorAll(
							self.nameSpaces.layers,
						);

						for (var j = 0; j < layers.length; j++) {
							(function (j) {
								var deep = layers[j].getAttribute(self.nameSpaces.deep);
								var disallow = layers[j].getAttribute("data-parallax-disallow");
								var itemX = disallow && disallow === "x" ? 0 : x / deep;
								var itemY = disallow && disallow === "y" ? 0 : y / deep;

								if (disallow && disallow === "both") return;
								layers[j].style.transform =
									"translateX(" + itemX + "%) translateY(" + itemY + "%)";
							})(j);
						}
					});
				})(i);
			}
		};
		this.init();
		return this;
	};

	document.addEventListener("shopify:section:load", imageMouseParallax);

	imageMouseParallax();
})();

/* Light header on dark bg */
(function () {
	let setLightHeader = () => {
		let headerWrapper = document.querySelector(".header-wrapper");
		let headerLogo =
			document.querySelector(
				".header > .header__heading-link .header__heading-logo:not(.header__heading-logo--overlay)",
			) ||
			document.querySelector(
				".header > .header__heading .header__heading-link .header__heading-logo:not(.header__heading-logo--overlay)",
			);
		let headerLogoOverlay = document.querySelector(
			".header__heading-logo--overlay",
		);
		const headerGroupSections = document.querySelectorAll(
			".shopify-section-group-header-group",
		);
		const header = document.querySelector(".shopify-section-header"); 
		const breadcrumbs = document.querySelector('.container .breadcrumb');

		const articleElement = document.querySelector(".article-template");

		const main = document.getElementById("MainContent");
		const sections = main.querySelectorAll(".shopify-section");
		let sectionFirstChild = sections[0].querySelector("div");

		if (sections[0].querySelector('.article-template')) {
			sectionFirstChild = articleElement;
		}
		let heroMedia = document.querySelector(".article-template__hero > .media");
		if (heroMedia) {
			if (heroMedia.classList.contains("article-template__hero-large")) {
				headerArticle.classList.add("article-template__header-large");
			} else {
				headerArticle.classList.remove("article-template__header-large");
			}
		}

		if (sections[0].classList.contains('product-section')) 
			sectionFirstChild = sections[0].querySelector("section");
		
			if (sections[0].classList.contains('section--overlay') || sectionFirstChild.classList.contains('section--has-overlayold')) {
			if ((sections[0].classList.contains('interactive-section') && 
					(sectionFirstChild.classList.contains("color-background-3") ||
					sectionFirstChild.classList.contains("color-background-4"))) ||
					(!sections[0].classList.contains('interactive-section') && !sectionFirstChild.classList.contains('header-overlay--dark'))
			) {
				if (breadcrumbs && !breadcrumbs.closest('main')) {
					breadcrumbs.classList.add('hidden');
				}
				headerWrapper.classList.add("header-wrapper--overlayold");
				if (headerLogoOverlay) {
					if (headerLogo) {
						headerLogo.classList.add("hide");
					}
					headerLogoOverlay.classList.add("show");
				} else {
					if (headerLogo) {
						headerLogo.classList.remove("hide");
					}
				}
			}
			else {
				if (breadcrumbs && !breadcrumbs.closest('main')) {
					breadcrumbs.classList.add('hidden');
				}
				headerWrapper.classList.remove("header-wrapper--overlayold");
			}

			if (headerGroupSections[headerGroupSections.length - 1] === header) {
				sections[0].classList.remove('not-margin');
				if (breadcrumbs && !breadcrumbs.closest('main')) {
					breadcrumbs.classList.add('hidden');
				}
			}
			else {
				sections[0].classList.add('not-margin');
				headerWrapper.classList.remove("header-wrapper--overlay");
				if (breadcrumbs) {
					breadcrumbs.classList.remove('hidden');
				}
			}
		}
		else {
			sections[0].classList.remove('not-margin');
			headerWrapper.classList.remove("header-wrapper--overlay");
			if (breadcrumbs) {
				breadcrumbs.classList.remove('hidden');
			}
		}
	}

	document.addEventListener("shopify:section:load", function () {
		setLightHeader();
	});

	document.addEventListener("shopify:section:unload", function () {
		setTimeout(function () {
			setLightHeader();
		}, 100);
	});

	document.addEventListener('shopify:section:reorder', function () {
		setLightHeader();
	})

	window.addEventListener("resize", function () {
		setLightHeader();
	});

	setLightHeader();

	let loopedSlides;
})();





$(document).on("change",".prd_var",function(event) {
event.preventDefault();
if($('.prd_var').is(":checked")){
event.preventDefault();
   var dataId = parseInt($('.prd_var').attr("data-value"));
   jQuery.ajax({
    url:'/cart/add.js',
    type: 'post',
    dataType: 'json',
     data: { id: dataId, quantity: 1 },
      success: function() {

      }
  });
}
});

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}


// $(document).on("click",".custom-add-to-cart-button",function(event) {
//  event.preventDefault();
//     var get_model_class = $(this).closest('.add-to-cart-wrapper');
//     var get_html = get_model_class.next('.custom_popup_extra').html();
//     var has_class = $(this).hasClass("has_default_varients");

//   if(has_class){
//     $(".custom-model-main").addClass("model-open");
//     // $('body').addClass('hide-scroll');
//     $('.custom-model-main').html('');
//     $('.custom-model-main').append(get_html);
//   }
//   else{
//     console.log(" else");
//     setTimeout(function() {
//     $(".custom-model-main").removeClass('model-open');
//       // $('body').removeClass('hide-scroll');
//     }, 1500);
//      var product_variant_id = $(this).next('.product-variant-id').val();
//      console.log("variantId", product_variant_id);
//       var lineItemId = 48169197928755;
//       var quantity = 1;
//       $.ajax({
//         type: 'POST',
//         url: window.Shopify.routes.root+ 'cart/add.js',
//         data: {
//           quantity: 1,
//           id: product_variant_id,
      
//         },
//         dataType: 'json',
//         success: function (data) {
//           console.log("onetime success");
//           // setTimeout(function() {
//           //   $('.drawer').addClass('active');
//           // }, 1000);
//           updateCart(lineItemId, quantity);
//         }
//       });
//   }
    
  
//   });


$(document).on('click', '.custom-add-to-cart-button', function(event) {
                 // console.log('defaultt click')
event.preventDefault();
    var get_model_class = $(this).closest('.add-to-cart-wrapper');
    var get_html = get_model_class.next('.custom_popup_extra').html();
    var has_class = $(this).hasClass("has_default_varients");


  if(has_class){
    $(".custom-model-main").addClass("model-open");
    // $('body').addClass('hide-scroll');
    $('.custom-model-main').html('');
    $('.custom-model-main').append(get_html);
  
  }
  else{
    var product_variant_id = $(this).next('.product-variant-id').val();
    console.log("variantId", product_variant_id);
    var cart = $('.header__cart');
    var imgtodrag = $(this).closest('.js-color-swatches-wrapper').find('img.motion-reduce').eq(0);
    console.log(imgtodrag)
    if (imgtodrag.length) {
        var imgclone = imgtodrag.clone()
            .offset({
                top: imgtodrag.offset().top,
                left: imgtodrag.offset().left
            })
            .css({
                'opacity': '100',
                'position': 'absolute',
                'height': '200px',
                'width': '200px',
                'z-index': '1000000'
            })
            .appendTo($('body'))
            .animate({
                'top': cart.offset().top + 10,
                'left': cart.offset().left + 10,
                'width': 75,
                'height': 75
            }, 1000, function() {
                // Animation complete, add product to cart
                var quantity = 1;
                $.ajax({
                    type: 'POST',
                    url: window.Shopify.routes.root + 'cart/add.js',
                    data: {
                        quantity: 1,
                        id: product_variant_id,
                    },
                    dataType: 'json',
                    success: function(data) {
                        console.log("onetime success");
                        setTimeout(function() {
                          // $('.drawer').addClass('active');
                          $(".custom-model-main").removeClass('model-open');
                        }, 1000);
                        animateupdateCart(quantity);
                    }
                });
            });
        // setTimeout(function () {
        //     cart.effect("shake", {
        //         times: 2
        //     }, 200);
        // }, 1500);
        imgclone.animate({
            'width': 0,
            'height': 0
        }, function () {
            $(this).detach()
        });
    }
  }
  });



$(document).on("change",".select_popup_variant",function() {
    console.log("selected changed");
    var selectedVariantId = $(this).val();
    var selectedVariantIds = $(this).next('.add-to-cart-form');
    selectedVariantIds.find('.product-variant-id').val(selectedVariantId);
   var selectedVariantImage = $(this).find('option:selected');

    // Get image source and alt attributes
    var imageSrc = selectedVariantImage.data('image-src');
    var imageAlt = selectedVariantImage.data('image-alt');
    console.log(imageSrc, "Image source");
    console.log(imageAlt, "Image alt text");
    // Update image attributes for the current product only
   var $productContainer = $(this).closest('.pop-up-content-wrap');
    var $productImage = $productContainer.find('.product-single__thumbnail-image');
    $productImage.attr('src', imageSrc);
    $productImage.attr('alt', imageAlt);
  });

  
   $(".custom-add-to-cart-button").mouseover(function(){
      // console.log('mouseover works');
       $(this).closest('.add-to-cart-wrapper').find(".lookatdetails").text('IN WARENKORB').css({'color':'black',"font-weight":"bold"});
    }).mouseout(function(){
        $(this).closest('.add-to-cart-wrapper').find(".lookatdetails").text('DETAILS ANSEHEN').css({'color':'#787878',"font-weight":"normal"});
    });

$(document).on("click",".close-btn",function() {
  console.log('removedddd')
  $(".custom-model-main").removeClass('model-open');
  // $('body').removeClass('hide-scroll');
  
});

// Function to update cart
function updateCart(lineItemId, quantity) {
      const data = {
          id: lineItemId,
          quantity: quantity
      };
      fetch('/cart/update.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'xmlhttprequest'
          },
          body: JSON.stringify(data)
      })
      .then(response => {
          if (response.ok) {
              return response.json();
          }
          throw new Error('Network response was not ok.');
      })
      .then(data => {
          $('.drawer').load(location.href + " .cart-drawer");
          $('.header__icon--cart').load(location.href + " .header__icon--cart");
          setTimeout(function() {
            $('.drawer').removeClass('is-empty');
          }, 300);
        setTimeout(function() {
            $('.drawer').addClass('active');
          	giftUpsell();
        	//   animateConfitti();

			initSimpleSlider();

        }, 800);
          console.log('Cart updated successfully upadteCart:', data);
          // $('.drawer').load(location.href + " .drawer");
      })
      .catch(error => {
          console.error('Error updating cart:', error);
      });
}

function matchHeight() {
	var columns = document.getElementsByClassName('card-information__wrapper');
	var maxHeight = 0;

	// Find the maximum height
	for (var i = 0; i < columns.length; i++) {
		var height = columns[i].clientHeight;
		if (height > maxHeight) {
			maxHeight = height;
		}
	}

	// Set all columns to the maximum height
	for (var i = 0; i < columns.length; i++) {
		columns[i].style.height = maxHeight + 'px';
	}
}

//animateeeeeeeeeeeeeeeeee

$(document).ready(function() {
  $(document).on('click', '.add-to-cart-animate', function(event) {
    event.preventDefault();
    var product_variant_id = $(this).next('.product-variant-id').val();
     var quantity = $(this).closest('.pop-up-content-wrap').find('.qty').val();
    console.log(quantity,"uhiuhiu--------------->")
    console.log("variantId", product_variant_id);
    var cart = $('.header__cart');
    var imgtodrag = $(this).closest('.pop-up-content-wrap').find('img.product-single__thumbnail-image').eq(0);
    if (imgtodrag.length) {
        var imgclone = imgtodrag.clone()
            .offset({
                top: imgtodrag.offset().top,
                left: imgtodrag.offset().left
            })
            .css({
                'opacity': '0.5',
                'position': 'absolute',
                'height': '150px',
                'width': '150px',
                'z-index': '100000'
            })
            .appendTo($('body'))
            .animate({
                'top': cart.offset().top + 10,
                'left': cart.offset().left + 10,
                'width': 75,
                'height': 75
            }, 1000, function() {
                // Animation complete, add product to cart
                $.ajax({
                    type: 'POST',
                    url: window.Shopify.routes.root + 'cart/add.js',
                    data: {
                        quantity: quantity,
                        id: product_variant_id,
                    },
                    dataType: 'json',
                    success: function(data) {
                        console.log("onetime success");
                        setTimeout(function() {
                          // $('.drawer').addClass('active');
                          $(".custom-model-main").removeClass('model-open');
                        }, 1000);
                        animateupdateCart(quantity);
                    }
                });
            });
        // setTimeout(function () {
        //     cart.effect("shake", {
        //         times: 2
        //     }, 200);
        // }, 1500);
        imgclone.animate({
            'width': 0,
            'height': 0
        }, function () {
            $(this).detach()
        });
    }
  });
});
 // Function to update cart
  function animateupdateCart(quantity) {
      const data = {
          quantity: quantity
      };
      fetch('/cart/update.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'xmlhttprequest'
          },
          body: JSON.stringify(data)
      })
      .then(response => {
          if (response.ok) {
              return response.json();
          }
          throw new Error('Network response was not ok.');
      })
      // .then(data => {
      //     $('.drawer').load(location.href + " .cart-drawer");
      //     $('.header__icon--cart').load(location.href + " .header__icon--cart");
      //     setTimeout(function() {
      //       // var popup = $('.main-popup').html();
      //       // console.log("popup", popup);
      //       // $('.custom-model-main').html('');
      //       // $('.custom-model-main').append(popup);
      //       // $(".custom-model-main").addClass('model-open');
      //      animateConfitti();
      //     }, 1000);
      //     console.log('Cart updated successfully:', data);
      // })
        .then(data => {

			$('.drawer').load(location.href + " .cart-drawer", function () {
				setTimeout(function() {
					// Remove empty state
					$('.drawer').removeClass('is-empty');

					// Open drawer
					$('.drawer').addClass('active');

					giftUpsell();

					// INIT SLICK AFTER HTML IS LOADED
					initSimpleSlider();
				}, 800);
			});

			$('.header__icon--cart').load(location.href + " .header__icon--cart");

			//   $('.drawer').load(location.href + " .cart-drawer");
			//   $('.header__icon--cart').load(location.href + " .header__icon--cart");
			//   setTimeout(function() {
			//     $('.drawer').removeClass('is-empty');
			//   }, 300);
			// setTimeout(function() {
			//     $('.drawer').addClass('active');
			//     giftUpsell();
			//    	// animateConfitti();

			// 	initSimpleSlider();

        	// }, 800);
          	console.log('Cart updated successfully animateupdateCart:', data);
          	// $('.drawer').load(location.href + " .drawer");
      	})
      	.catch(error => {
        	console.error('Error updating cart:', error);
      	});
  }
// $(document).on("click",".closebtn",function() {
//   console.log('removedddd')
//   $(".custom-model-main").removeClass('model-open');
// });
function animateConfitti() {
confetti({
  particleCount: 1000,
  spread: window.innerWidth,
  origin: { x: 0.5, y: 0.6 },
  zIndex: 99999,
});
}


      
      
var TwaSettingsSwiper = {
      
	init: function() {
  
		this.TwaSettingsCarousel();
  
	},
  
	TwaSettingsCarousel: function() {
  
		document.querySelectorAll(".twa__swiper").forEach((e => {
  
			this.TwaCarousel(e);
  
		}))
  
	},
  
	TwaCarousel: function(e) {
  
		var t = "true" === e?.dataset.autoplay,
  
			n = "true" === e.dataset.loop,
  
			w = e?.dataset.rows ? e?.dataset.row : 1,
  
			o = e?.dataset.slideshow ? e?.dataset.slideshow : 0,
  
			pgm = e?.dataset.spgmobile ? e?.dataset.spgmobile : 1,
  
			pgt = e?.dataset.spgtablet ? e?.dataset.spgtablet : 1,
  
			pgd = e?.dataset.spgdesktop ? e?.dataset.spgdesktop : 1,
  
			i = e?.dataset.desktop ? e?.dataset.desktop : 4,
  
			s = e?.dataset.tablet ? e?.dataset.tablet : 2,
  
			r = e?.dataset.mobile ? e?.dataset.mobile : 1,
  
			a = e?.dataset.autoplaySpeed ? e?.dataset.autoplaySpeed : 3e3,
  
			c = e?.dataset.speed ? e?.dataset.speed : 400,
  
			l = e?.dataset.effect ? e?.dataset.effect : "slide",
  
			d = e?.dataset.sectionId,
  
			u = e?.dataset.row ? e?.dataset.row : 1,
  
			ut = e?.dataset.rowtablet ? e?.dataset.rowtablet : 1,
  
			um = e?.dataset.rowmobile ? e?.dataset.rowmobile : 1,
  
			p = window.innerWidth,
  
			m = e?.dataset.spacing ? e?.dataset.spacing : 0;
  
			cs = "true" === e.dataset.centerslide, 
  
			desktop = parseInt(pgd);
  
			tablet = parseInt(pgt);
  
			mobile = parseInt(pgm);
  
			al = e?.dataset.arrowleft ? e?.dataset.arrowleft : "swiper-button-prev",
  
			ar = e?.dataset.arrowright ? e?.dataset.arrowright : "swiper-button-next",
  
			m = Number(m), a = Number(a), c = Number(c), p <= 767 ? m >= 15 && (m = 15) : p <= 1199 && m >= 30 && (m = 30), new Swiper("#twa__swiper-" + d, {
  
			slidesPerView: r,
  
			slidesPerColumn: w,
  
			slidesPerGroup: mobile, 
  
			spaceBetween: m,
  
			centeredSlides: cs,
  
			autoplay: t,
  
			delay: a,
  
			loop: n,
  
			effect: l,
  
			speed: c,
  
			watchSlidesProgress: !0,
  
			watchSlidesVisibility: !0,
  
			draggable: true,
  
			grid: {
  
				rows: um,
  
				fill: "row"
  
			},
  
			// navigation: {
  
			//     nextEl: e.querySelector(`.${ar}`),
  
			//     prevEl: e.querySelector(`.${al}`)
  
			// },
  
			navigation: {
  
			  nextEl: `.${ar}`,
  
			  prevEl: `.${al}`,
  
			},
  
	  autoplay: {
  
			  delay: 9000,
  
		  },
  
			pagination: {
  
				clickable: !0,
  
				el: e.querySelector(".swiper-pagination")
  
			},
  
			breakpoints: {
  
				768: {
  
					slidesPerView: s,
  
					centeredSlides: cs,
  
					slidesPerGroup: tablet,
  
					grid: {
  
					  rows: ut,
  
					  fill: "row"
  
					}
  
				},
  
				1450: {
  
					slidesPerView: i,
  
					slidesPerGroup: desktop,
  
					grid: {
  
					  rows: u, 
  
					  fill: "row"
  
					}
  
					//centeredSlides: cs,
  
				}
  
			}
  
		})
  
	}
  
  };
  
  TwaSettingsSwiper.init();
  
	  // swiper js end


/*******************************************************
 * GLOBAL PROTECTION — Prevent Page Reload ALWAYS
 *******************************************************/
document.getElementById('cart-discount-form').addEventListener(
    'submit',
    function(e) {
        e.preventDefault();
    },
    true // capture phase (prevents ALL other submit handlers)
);


/*******************************************************
 * DISCOUNT APPLY HANDLER
 *******************************************************/

$(document).on('submit', '#cart-discount-form', function(e) {
    e.preventDefault(); // stops page reload

	let existingCodes = [];
    $('.discount-code__code-list-item__text').each(function() {
        existingCodes.push($(this).text().trim());
    });

    const newCode = $('#discount-code-input').val().trim();
    const successMsg = $('#discount-success');
    const errorMsg   = $('#discount-error');
   if (!existingCodes.includes(newCode)) {
        existingCodes.push(newCode);
    }

    successMsg.hide();
    errorMsg.hide();

    $.ajax({
        url: '/cart/update.js',
        method: 'POST',
        // data: JSON.stringify({ discount: code }),
		data: JSON.stringify({ discount: existingCodes.join(',') }),
        dataType: 'json',
        contentType: 'application/json; charset=UTF-8',
        headers: {
            'X-Requested-With': 'xmlhttprequest'
        },
        success: function(res) {
            const discountInfo = res.discount_codes?.[0];

            if (discountInfo && discountInfo.applicable === true) {
                successMsg.text("Rabatt erfolgreich angewendet!").show();
                errorMsg.hide();

                // Call your theme refresh logic
                refreshCartDrawer(res);

            } else {
                errorMsg.text("Ungültiger oder abgelaufener Rabattcode.").show();
                successMsg.hide();
            }
        },
        error: function() {
            errorMsg.text("Etwas ist schiefgelaufen. Versuchen Sie es erneut.").show();
            successMsg.hide();
        }
    });
});


$(document).on('click', '.discount-code__code-list-item__clear', function (e) {
    e.preventDefault();
    e.stopPropagation();

	const codeToRemove = $(this).data('discount-code'); // This should be the raw code
    let remainingCodes = [];

    $('.discount-code__code-list-item__text').each(function() {
        let currentCode = $(this).text().trim();
        if (currentCode !== decodeURIComponent(codeToRemove)) {
            remainingCodes.push(currentCode);
        }
    });

	$('.cart__checkout-button').addClass('loading');

    $.ajax({
        url: '/cart/update.js',
        type: 'POST',
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify({ discount: remainingCodes.join(',') }),
        success: function (cart) {
            console.log('Discount removed:', cart);

			$('.cart__checkout-button').removeClass('loading');

            refreshCartDrawer(cart);
        },
        error: function (xhr, status, error) {
            console.error('Error removing discount:', error);
        }
    });
});



// document.getElementById('cart-discount-form').addEventListener('submit', function(event) {
//     event.preventDefault(); // double protection — does not allow reload

//     const code = document.getElementById('discount-code-input').value.trim();
//     const successMsg = document.getElementById('discount-success');
//     const errorMsg   = document.getElementById('discount-error');

//     successMsg.style.display = "none";
//     errorMsg.style.display = "none";

//     fetch('/cart/update.js', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//             'X-Requested-With': 'xmlhttprequest'
//         },
//         body: JSON.stringify({
//             discount: code
//         })
//     })
//     .then(response => response.json().then(data => ({
//         status: response.status,
//         body: data
//     })))
//     .then(res => {
//         console.log("DISCOUNT RESPONSE:", res);

//         const discountInfo = res.body.discount_codes?.[0];

//         // SUCCESS → applicable === true
//         if (discountInfo && discountInfo.applicable === true) {
            
//             successMsg.textContent = "Discount applied successfully!";
//             successMsg.style.display = "block";
//             errorMsg.style.display = "none";

//             refreshCartDrawer(res.body);  // EXACT THEME LOGIC

//         } else {
//             errorMsg.textContent = "Invalid or expired discount code.";
//             errorMsg.style.display = "block";
//             successMsg.style.display = "none";
//         }
//     })
//     .catch(err => {
//         console.error("DISCOUNT ERROR:", err);
//         errorMsg.textContent = "Something went wrong. Try again.";
//         errorMsg.style.display = "block";
//         successMsg.style.display = "none";
//     });
// });

// Click event for add-to-cart buttons inside cart drawer
$(document).on("click", ".cart-drawer-itemscart-drawer-items", function () {
    const variantId = $(this).data("variant-id");
    if (!variantId) return;

    // ADD TO CART AJAX
    $.ajax({
        url: "/cart/add.js",
        method: "POST",
        data: JSON.stringify({
            id: variantId,
            quantity: 1
        }),
        dataType: "json",
        contentType: "application/json; charset=UTF-8",
        success: function (result) {
            console.log("Added to cart:", result);

            // Refresh cart drawer
            refreshCartDrawer(result);
        },
        error: function (xhr) {
            console.error("Error adding to cart", xhr.responseText);
        }
    });
});

/*******************************************************
 * REFRESH CART DRAWER — SAME AS updateCart()
 *******************************************************/
function refreshCartDrawer(data) {

	$('.drawer').load(location.href + " .cart-drawer", function () {
		setTimeout(function() {
			$('.drawer').removeClass('is-empty');
		}, 500);

		setTimeout(function() {
			// Open drawer
			$('.drawer').addClass('active');

			giftUpsell();

			// INIT SLICK AFTER HTML IS LOADED
			initSimpleSlider();
		}, 1000);
	});

    $('.header__icon--cart').load(location.href + " .header__icon--cart");
    console.log("Cart updated successfully refreshCartDrawer:", data);
}

//Neha//

//Slider Container js//

	// Function to toggle arrows
	function toggleArrows(slick, currentSlide) {

		var totalSlides = slick.slideCount;
		var leftArrow = $('.arrow-btn.left');
		var rightArrow = $('.arrow-btn.right');

		// First slide FULLY visible
		if (currentSlide === 0) {
			leftArrow.hide();
		} else {
			leftArrow.show();
		}

		// Last slide FULLY visible
		if (currentSlide === totalSlides - 1) {
			rightArrow.hide();
		} else {
			rightArrow.show();
		}
	}
	function initSimpleSlider() {

		console.log("initSimpleSlider");

		var slider = $('.simple-slider');
		var leftArrow = $('.arrow-btn.left');
		var rightArrow = $('.arrow-btn.right');

		// Safety check
		if (!slider.length) return;

		// Prevent double initialization
		if (slider.hasClass('slick-initialized')) {
			slider.slick('unslick');
		}

		// On init
		slider.on('init', function (event, slick) {
			toggleArrows(slick, 0);
		});

		// After slide change
		slider.on('afterChange', function (event, slick, currentSlide) {
			toggleArrows(slick, currentSlide);
		});

		// Initialize Slick
		slider.slick({
			slidesToShow: 1.6,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			infinite: false,
			swipe: true,
			draggable: true,
			touchMove: true,
			accessibility: false,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1.2
					}
				}
			]
		});

		// Custom arrow clicks
		leftArrow.on('click', function () {
			slider.slick('slickPrev');
		});

		rightArrow.on('click', function () {
			slider.slick('slickNext');
		});
	}

	$(document).ready(function () {

		initSimpleSlider();

	});
	//end Slider Container js//